import React from 'react';
import { ExposureWidgetItemBrand } from '../../../../../../../types/widget';
import { BrandCardStyle } from './style';
import Img from '../../../../../../../components/Img/Img';

interface BrandCardProps {
  widgetBrandItem: ExposureWidgetItemBrand;
}

const BrandCard = (props: BrandCardProps): JSX.Element => {
  const { widgetBrandItem } = props;

  const mainImg = widgetBrandItem.attachment?.[0];

  return (
    <BrandCardStyle>
      <Img clickAble={false} src={mainImg?.url || widgetBrandItem.brand.imageUrl} />
      <div className="title">
        {widgetBrandItem.title ? (
          widgetBrandItem.title
        ) : (
          <span className="require-info">위젯 브랜드 아이템 타이틀을 설정해주세요.</span>
        )}
      </div>
      {widgetBrandItem.contents && <div className="contents">{widgetBrandItem.contents}</div>}
    </BrandCardStyle>
  );
};

export default BrandCard;
